import React, { useContext, useState } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import * as yup from "yup";
import { toast } from "react-toastify";
import { Form } from "semantic-ui-react";
import styled from "styled-components";
import { Context } from "../../../context/globalContext";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { getUser } from "../services";
import OneSignal from "react-onesignal";
import { ThemeProps } from "../../genericComponents/globalStyles";
import { routes } from "../../../helpers/routes";
import googleIcon from "../../../assets/images/icons/google.png";
import { Divider } from "antd";
import { trackIdentity } from "../../../helpers/analytics";

const googleProvider = new firebase.auth.GoogleAuthProvider();

const loginSchema = yup.object().shape({
  email: yup.string().required("Email is a required field"),
  password: yup.string().required("Password is a required field"),
});

export default function SignIn(props) {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const {
    graphQLClient,
    dispatch: { login },
  } = useContext(Context);
  const [signInWithFormn, setSignInWithFormn] = useState(false);

  async function onSubmit(data) {
    try {
      setLoading(true);
      const response = await firebase
        .auth()
        .signInWithEmailAndPassword(data.email, data.password);
      if (response.user) {
        const userData = await getUser(graphQLClient, data.email);
        console.log(userData);
        login(userData);
        //window.$crisp.push(["set", "user:email", [data.email]]);
        trackIdentity(data.email, {
          username: userData?.userAccount?.username,
          due_date: userData?.userAccount?.due_date,
          membership: userData?.userAccount?.membership,
        });

        //toast.info("Welcome to GABA !");
        history.replace(`/home/${userData?.userAccount?.username || ""}`);
      } else {
        toast.error("Unable to log in with provided credentials");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Unable to log in with provided credentials");
      setLoading(false);
    }
  }

  const { errors, handleChange, handleSubmit, values, touched } = useFormik({
    initialValues: {
      ...{
        email: "",
        password: "",
      },
    },
    validationSchema: loginSchema,
    onSubmit: onSubmit,
  });

  function googleAuthHandle() {
    firebase
      .auth()
      .signInWithPopup(googleProvider)
      .then((res) => {
        console.log('firebase res',res.user);
        trackIdentity(res.user.email, {
          "First Name": res.user.displayName?.split(' ')[0]
          
        });
        
      })
      .catch((error) => {
        console.log(error.message);
      });
  }

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <RowSpaceBeetwenContainer>
        <HeaderTitle>Sign in</HeaderTitle>
        <div>
          <AlreadyMemberLabel>Not yet a member?</AlreadyMemberLabel>
          <SignInButton onClick={() => history.replace(routes.SIGNUP)}>
            Sign Up
          </SignInButton>
        </div>
      </RowSpaceBeetwenContainer>
      <Divider
        style={{ borderColor: ThemeProps.color.gabaYellow, borderWidth: "2px" }}
      />

      {!signInWithFormn ? (
        <>
          <ButtonIcon
            onClick={googleAuthHandle}
            backgroundColor={ThemeProps.color.softGray}
          >
            <img
              src={googleIcon}
              style={{ width: "18px", height: "18px" }}
              alt=''
            />
            <p style={{ display: "flex", flex: 1, justifyContent: "center" }}>
              Sign in with Google
            </p>
          </ButtonIcon>
          <Divider plain>Or</Divider>
          <ButtonIcon
            onClick={() => setSignInWithFormn(true)}
            backgroundColor={ThemeProps.color.gabaYellow}
          >
            Sign in with email
          </ButtonIcon>
        </>
      ) : (
        <>
          <Form.Field required>
            <Label>Email Address </Label>
            <InputStyled
              onChange={handleChange}
              name='email'
              type='text'
              id='inputEmail'
              autoFocus
            />
            {errors.email && touched.email && (
              <span className={"text-danger"}>{errors.email}</span>
            )}
          </Form.Field>
          <Form.Field required>
            <Label>Password</Label>
            <InputStyled
              onChange={handleChange}
              name='password'
              type='password'
              id='inputPassword'
            />
            {errors.password && touched.password && (
              <span className={"text-danger"}>{errors.password}</span>
            )}
          </Form.Field>
          <br />
          <Form.Button
            content='Sign In GABA'
            primary={values.email && values.password ? true : false}
            fluid
            loading={loading}
            size='huge'
            // disabled={loading}
          />
          <ForgotPassword
            onClick={(e) => {
              e.preventDefault();
              firebase
                .auth()
                .sendPasswordResetEmail(values.email)
                .then(() => {
                  toast.success("reset password send");
                })
                .catch((error) => {
                  // An error happened.\
                  console.log(error);
                  toast.error("An error ocurred");
                });
            }}
          >
            Forgot password?
          </ForgotPassword>
        </>
      )}
    </FormWrapper>
  );
}

const FormWrapper = styled(Form)`
  margin: 32px auto;
  width: 50%;
  @media (max-width: 768px) {
    width: 80%;
  }
`;
const Label = styled.label`
  font-size: 1.34em !important;
`;
const InputStyled = styled.input``;
const ForgotPassword = styled.button`
  background: none;
  border: none;
  outline: none;
  color: #4183c4;
`;

const RowSpaceBeetwenContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const SignInButton = styled.button`
  border: none;
  margin-left: 12px;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 600;
  background-color: ${ThemeProps.color.gabaGreen}44;
`;
const AlreadyMemberLabel = styled.label`
  font-weight: 600;
  color: #0007;
`;
const HeaderTitle = styled.label`
  font-size: 1.7em;
  font-weight: 600;
`;
const ButtonIcon = styled.button`
  border: none;
  outline: none;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  display: flex;
  justify-content: center;
  font-weight: 600;
  box-shadow: 0px 1px 4px 0px rgba(17, 23, 65, 0.33);
  background-color: ${(p) => p.backgroundColor};
`;
